import React, {FC, useEffect} from 'react';
import {useSelector} from 'react-redux';

import BackButton from '../../../../../components/BackButton/BackButton';
import {ArticlePageLayout} from '../../../../../components/DataDisplay';
import {ContentWrapper, MaxWidthContainer} from '../../../../../components/Layout';
import Container from '../../../../../components/Layout/Container/Container';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';
import analyticsService from '../../../../../services/analyticsService';
import connectivityService from '../../../../../services/device/connectivityService';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import {selectIotDeviceType} from '../../../../../state/selectors/iotDevice';

interface IProps {
    onClose: () => void;
    onNextClick?: () => void;
}

const FWUFirstStep: FC<IProps> = ({onClose, onNextClick}) => {
    const localizedStrings = getLocalizedStrings();
    const isBle = connectivityService.isBle();
    const deviceType = useSelector(selectIotDeviceType);

    useDocumentTitle(localizedStrings[localizationKeys.ACCESSIBILITY_FEW_MORE_STEPS_PAGE_TITLE]);

    useEffect(() => {
        analyticsService.pushSpecialFlowNextEvent(deviceType);
    }, []);

    return (
        <ContentWrapper>
            <MaxWidthContainer>
                {!isBle && (
                    <Container className='left-0 transform-none' isFloatHeight>
                        <BackButton
                            className='left-8 top-0 md:left-[60px]'
                            ariaLabel={
                                localizedStrings[
                                    localizationKeys.FWU_ADDITIONAL_STEPS_GUIDE_BTN_BACK_TO_ABOUT_DEVICE_ARIA_LABEL
                                ]
                            }
                            onClick={onClose}
                        />
                    </Container>
                )}
                <ArticlePageLayout
                    titleKey={localizationKeys.IQOS_DUO_STEP1_TITLE}
                    descriptionKey={localizationKeys.IQOS_DUO_STEP1_DESCRIPTION}
                    buttonPrimary={{
                        onClick: onNextClick,
                        textKey: localizationKeys.IQOS_DUO_STEP1_BUTTON_TEXT,
                    }}
                />
            </MaxWidthContainer>
        </ContentWrapper>
    );
};

export default FWUFirstStep;
